export const getStoredAccessToken = () => {
  return localStorage.getItem('mintAccessToken')
}

export const isTestMode = () => {
  return !!getStoredAccessToken()
}